import React from 'react'
import { ClickEvent, NonInteractiveElements } from '../../typescript/utility'

type OnClick = (e: ClickEvent<NonInteractiveElements> | React.KeyboardEvent<NonInteractiveElements>) => void

export const accessibleNoninteractiveElementClick = (onClick: OnClick) => ({
  role: 'button',
  onClick,
  onKeyDown: (event: React.KeyboardEvent<NonInteractiveElements>) => {
    // TODO look into converting this to code instead of these two deprecated event properties
    // also would be good to guard against cases where the onclick requires a mouse event and wouln't work with a
    // keyboard event
    const code = event.charCode || event.keyCode
    if (code === 13 || code === 32) onClick(event)
  },
  tabIndex: 0,
})
